export default __webpack_public_path__ + "assets/images/4ffee5d785cb20d35554df1eea3d6888.png";